export * from './bound-content.directive';
